// NSW High Schools list - Public, Catholic, and Independent schools
// Format: "School Name (Suburb)"

export const nswSchools = [
  // === PUBLIC SCHOOLS ===
  "Airds High School (Campbelltown)",
  "Albion Park High School (Albion Park)",
  "Albury High School (Albury)",
  "Alstonville High School (Alstonville)",
  "Ambarvale High School (Rosemeadow)",
  "Armidale Secondary College (Armidale)",
  "Arthur Phillip High School (Parramatta)",
  "Ashcroft High School (Ashcroft)",
  "Ashfield Boys High School (Ashfield)",
  "Asquith High School (Asquith)",
  "Auburn Girls High School (Auburn)",
  "Aurora College (Lindfield)",
  "Ballina Coast High School (Ballina)",
  "Banora Point High School (Banora Point)",
  "Bankstown Girls High School (Bankstown)",
  "Bankstown Senior College (Bankstown)",
  "Barham High School (Barham)",
  "Barrenjoey High School (Avalon)",
  "Bass High School (Bass Hill)",
  "Batemans Bay High School (Batehaven)",
  "Baulkham Hills High School (Baulkham Hills)",
  "Bayside High School (Kogarah)",
  "Bega High School (Bega)",
  "Bellingen High School (Bellingen)",
  "Belmont High School (Belmont)",
  "Belmore Boys High School (Belmore)",
  "Beverly Hills Girls High School (Beverly Hills)",
  "Billabong High School (Culcairn)",
  "Birrong Boys High School (Birrong)",
  "Birrong Girls High School (Birrong)",
  "Blacktown Boys High School (Blacktown)",
  "Blacktown Girls High School (Blacktown)",
  "Blakehurst High School (Blakehurst)",
  "Blaxland High School (Blaxland)",
  "Blayney High School (Blayney)",
  "Bomaderry High School (Bomaderry)",
  "Bombala High School (Bombala)",
  "Bonnyrigg High School (Bonnyrigg)",
  "Bossley Park High School (Bossley Park)",
  "Bourke High School (Bourke)",
  "Bowral High School (Bowral)",
  "Box Hill High School (Box Hill)",
  "Bradfield College (St Leonards)",
  "Brisbane Water Secondary College Umina Campus (Umina)",
  "Brisbane Water Secondary College Woy Woy Campus (Woy Woy)",
  "Broken Hill High School (Broken Hill)",
  "Bulli High School (Bulli)",
  "Bungendore High School (Bungendore)",
  "Burwood Girls High School (Croydon)",
  "Byron Bay High School (Byron Bay)",
  "Cabramatta High School (Cabramatta)",
  "Callaghan College Jesmond Senior Campus (Jesmond)",
  "Callaghan College Wallsend Campus (Wallsend)",
  "Callaghan College Waratah Campus (Waratah)",
  "Cambridge Park High School (Cambridge Park)",
  "Camden Haven High School (Laurieton)",
  "Camden High School (Camden)",
  "Cammeraygal High School (Crows Nest)",
  "Campbelltown Performing Arts High School (Campbelltown)",
  "Canley Vale High School (Canley Vale)",
  "Canobolas High School (Orange)",
  "Canowindra High School (Canowindra)",
  "Canterbury Boys High School (Canterbury)",
  "Canterbury Girls High School (Canterbury)",
  "Cardiff High School (Cardiff)",
  "Caringbah High School (Caringbah)",
  "Carlingford High School (Carlingford)",
  "Casino High School (Casino)",
  "Castle Hill High School (Castle Hill)",
  "Casula High School (Casula)",
  "Cecil Hills High School (Cecil Hills)",
  "Central Sydney Intensive English High School (Alexandria)",
  "Cessnock High School (Cessnock)",
  "Chatham High School (Taree)",
  "Chatswood High School (Chatswood)",
  "Cheltenham Girls High School (Beecroft)",
  "Cherrybrook Technology High School (Cherrybrook)",
  "Chester Hill High School (Chester Hill)",
  "Chifley College Bidwill Campus (Bidwill)",
  "Chifley College Dunheved Campus (North St Marys)",
  "Chifley College Mount Druitt Campus (Mount Druitt)",
  "Chifley College Senior Campus (Mount Druitt)",
  "Chifley College Shalvey Campus (Shalvey)",
  "Cobar High School (Cobar)",
  "Coffs Harbour High School (Coffs Harbour)",
  "Coffs Harbour Senior College (Coffs Harbour)",
  "Colo High School (North Richmond)",
  "Colyton High School (St Marys)",
  "Concord High School (Concord)",
  "Condell Park High School (Condell Park)",
  "Condobolin High School (Condobolin)",
  "Conservatorium High School (Sydney)",
  "Coonabarabran High School (Coonabarabran)",
  "Coonamble High School (Coonamble)",
  "Cootamundra High School (Cootamundra)",
  "Corrimal High School (Corrimal)",
  "Corowa High School (Corowa)",
  "Cowra High School (Cowra)",
  "Cranebrook High School (Cranebrook)",
  "Crestwood High School (Baulkham Hills)",
  "Cronulla High School (Cronulla)",
  "Crookwell High School (Crookwell)",
  "Cumberland High School (Carlingford)",
  "Dapto High School (Dapto)",
  "Davidson High School (Frenchs Forest)",
  "Deniliquin High School (Deniliquin)",
  "Denison College of Secondary Education, Bathurst High Campus (Bathurst)",
  "Denison College of Secondary Education, Kelso High Campus (Kelso)",
  "Doonside High School (Doonside)",
  "Dorrigo High School (Dorrigo)",
  "Dubbo College Delroy Campus (Dubbo West)",
  "Dubbo College Senior Campus (Dubbo)",
  "Dubbo College South Campus (Dubbo)",
  "Dulwich High School of Visual Arts and Design (Dulwich Hill)",
  "Dungog High School (Dungog)",
  "Eagle Vale High School (Eagle Vale)",
  "East Hills Boys High School (Panania)",
  "East Hills Girls Technology High School (Panania)",
  "Eden Marine High School (Eden)",
  "Elderslie High School (Narellan)",
  "Elizabeth Macarthur High School (Narellan)",
  "Endeavour Sports High School (Caringbah)",
  "Engadine High School (Engadine)",
  "Epping Boys High School (Eastwood)",
  "Erina High School (Erina)",
  "Erskine Park High School (Erskine Park)",
  "Evans High School (Blacktown)",
  "Fairfield High School (Fairfield)",
  "Fairvale High School (Fairfield West)",
  "Farrer Memorial Agricultural High School (Calala)",
  "Figtree High School (Figtree)",
  "Finley High School (Finley)",
  "Five Islands Secondary College (Port Kembla)",
  "Forbes High School (Forbes)",
  "Fort Street High School (Petersham)",
  "Francis Greenway High School (Woodberry)",
  "Galston High School (Galston)",
  "Georges River College, Hurstville Campus (Hurstville)",
  "Georges River College, Oatley Senior Campus (Oatley)",
  "Georges River College, Peakhurst Campus (Peakhurst)",
  "Georges River College, Penshurst Campus (Penshurst)",
  "Gilgandra High School (Gilgandra)",
  "Girraween High School (Girraween)",
  "Glen Innes High School (Glen Innes)",
  "Glendale Technology High School (Glendale)",
  "Glenmore Park High School (Glenmore Park)",
  "Glenwood High School (Glenwood)",
  "Gledswood Hills High School (Gledswood Hills)",
  "Gloucester High School (Gloucester)",
  "Gorokan High School (Lake Haven)",
  "Gosford High School (Gosford)",
  "Goulburn High School (Goulburn)",
  "Grafton High School (Grafton)",
  "Granville Boys High School (Granville)",
  "Granville South Creative and Performing Arts High School (Guildford)",
  "Great Lakes College Forster Campus (Forster)",
  "Great Lakes College Senior Campus (Tuncurry)",
  "Great Lakes College Tuncurry Campus (Tuncurry)",
  "Greystanes High School (Greystanes)",
  "Griffith High School (Griffith)",
  "Gulgong High School (Gulgong)",
  "Gundagai High School (Gundagai)",
  "Gunnedah High School (Gunnedah)",
  "Gymea Technology High School (Gymea)",
  "Hastings Secondary College, Port Macquarie Campus (Port Macquarie)",
  "Hastings Secondary College, Westport Campus (Port Macquarie)",
  "Hawkesbury High School (Freemans Reach)",
  "Hay War Memorial High School (Hay)",
  "Heathcote High School (Heathcote)",
  "Henry Kendall High School (Gosford)",
  "Holroyd High School (Greystanes)",
  "Holsworthy High School (Holsworthy)",
  "Homebush Boys High School (Homebush)",
  "Hornsby Girls High School (Hornsby)",
  "Hornsby High School (Asquith)",
  "Hoxton Park High School (Hinchinbrook)",
  "Hunter River High School (Heatherbrae)",
  "Hunter Sports High School (Gateshead)",
  "Hunters Hill High School (Hunters Hill)",
  "Hurlstone Agricultural High School (Glenfield)",
  "Illawarra Sports High School (Berkeley)",
  "Ingleburn High School (Ingleburn)",
  "Inner Sydney High School (Surry Hills)",
  "Inverell High School (Inverell)",
  "Irrawang High School (Raymond Terrace)",
  "J J Cahill Memorial High School (Mascot)",
  "James Busby High School (Green Valley)",
  "James Fallon High School (North Albury)",
  "James Meehan High School (Macquarie Fields)",
  "James Ruse Agricultural High School (Carlingford)",
  "Jamison High School (South Penrith)",
  "Jerrabomberra High School (Jerrabomberra)",
  "Jindabyne High School (Jindabyne)",
  "John Edmondson High School (Horningsea Park)",
  "Junee High School (Junee)",
  "Kanahooka High School (Kanahooka)",
  "Kandos High School (Kandos)",
  "Karabar High School (Queanbeyan)",
  "Kariong Mountains High School (Kariong)",
  "Katoomba High School (Katoomba)",
  "Keira High School (Fairy Meadow)",
  "Kellyville High School (Kellyville)",
  "Kempsey High School (Kempsey)",
  "Kiama High School (Kiama)",
  "Killara High School (Killara)",
  "Killarney Heights High School (Killarney Heights)",
  "Kincumber High School (Kincumber)",
  "Kingscliff High School (Kingscliff)",
  "Kingsgrove High School (Kingsgrove)",
  "Kingsgrove North High School (Kingsgrove)",
  "Kingswood High School (Kingswood)",
  "Kirrawee High School (Kirrawee)",
  "Kogarah High School (Kogarah)",
  "Kooringal High School (Kooringal)",
  "Kotara High School (Adamstown)",
  "Ku-ring-gai High School (North Turramurra)",
  "Kurri Kurri High School (Kurri Kurri)",
  "Kyogle High School (Kyogle)",
  "Lake Illawarra High School (Lake Illawarra)",
  "Lake Macquarie High School (Booragul)",
  "Lake Munmorah High School (Lake Munmorah)",
  "Lambton High School (Lambton)",
  "Leeton High School (Leeton)",
  "Leumeah High School (Leumeah)",
  "Lisarow High School (Lisarow)",
  "Lithgow High School (Lithgow)",
  "Liverpool Boys High School (Liverpool)",
  "Liverpool Girls High School (Liverpool)",
  "Lurnea High School (Lurnea)",
  "Macarthur Girls High School (Parramatta)",
  "Macintyre High School (Inverell)",
  "Macksville High School (Macksville)",
  "Maclean High School (Maclean)",
  "Macquarie Fields High School (Macquarie Fields)",
  "Maitland Grossmann High School (East Maitland)",
  "Maitland High School (East Maitland)",
  "Marrickville High School (Marrickville)",
  "Marsden High School (Meadowbank)",
  "Matraville Sports High School (Chifley)",
  "Melonba High School (Marsden Park)",
  "Melville High School (Kempsey)",
  "Menai High School (Menai)",
  "Merewether High School (Broadmeadow)",
  "Merrylands High School (Merrylands)",
  "Miller High School (Miller)",
  "Mitchell High School (Blacktown)",
  "Model Farms High School (Baulkham Hills)",
  "Monaro High School (Cooma North)",
  "Moorebank High School (Moorebank)",
  "Moree Secondary College (Moree)",
  "Morisset High School (Morisset)",
  "Moruya High School (Moruya)",
  "Mosman High School (Mosman)",
  "Moss Vale High School (Moss Vale)",
  "Mount Annan High School (Mount Annan)",
  "Mount Austin High School (Wagga Wagga)",
  "Mount View High School (Cessnock)",
  "Mudgee High School (Mudgee)",
  "Muirfield High School (North Rocks)",
  "Mullumbimby High School (Mullumbimby)",
  "Mulwaree High School (Goulburn)",
  "Murrumburrah High School (Harden)",
  "Murwillumbah High School (Murwillumbah)",
  "Muswellbrook High School (Muswellbrook)",
  "Nambucca Heads High School (Nambucca Heads)",
  "Narara Valley High School (Narara)",
  "Narooma High School (Narooma)",
  "Narrabeen Sports High School (North Narrabeen)",
  "Narrabri High School (Narrabri)",
  "Narrandera High School (Narrandera)",
  "Narromine High School (Narromine)",
  "Nepean Creative and Performing Arts High School (Emu Plains)",
  "Newcastle High School (Hamilton)",
  "Newtown High School of Performing Arts (Newtown)",
  "North Sydney Boys High School (North Sydney)",
  "North Sydney Girls High School (Crows Nest)",
  "Northern Beaches Secondary College Balgowlah Boys Campus (Balgowlah)",
  "Northern Beaches Secondary College Cromer Campus (Cromer)",
  "Northern Beaches Secondary College Freshwater Senior Campus (Freshwater)",
  "Northern Beaches Secondary College Mackellar Girls Campus (Manly Vale)",
  "Northern Beaches Secondary College Manly Campus (North Curl Curl)",
  "Northlakes High School (San Remo)",
  "Northmead Creative and Performing Arts High School (Northmead)",
  "Normanhurst Boys High School (Normanhurst)",
  "Nowra High School (Nowra)",
  "NSW School of Languages (Petersham)",
  "Nyngan High School (Nyngan)",
  "Oak Flats High School (Oak Flats)",
  "Oberon High School (Oberon)",
  "Oran Park High School (Oran Park)",
  "Orange High School (Orange)",
  "Orara High School (Coffs Harbour)",
  "Oxley High School (North Tamworth)",
  "Parkes High School (Parkes)",
  "Parramatta High School (Parramatta)",
  "Peel High School (Tamworth)",
  "Pendle Hill High School (Wentworthville)",
  "Pennant Hills High School (Pennant Hills)",
  "Penrith High School (Penrith)",
  "Picnic Point High School (Picnic Point)",
  "Picton High School (Picton)",
  "Pittwater High School (Mona Vale)",
  "Plumpton High School (Plumpton)",
  "Port Hacking High School (Miranda)",
  "Prairiewood High School (Prairiewood)",
  "Punchbowl Boys High School (Punchbowl)",
  "Quakers Hill High School (Quakers Hill)",
  "Queanbeyan High School (Queanbeyan)",
  "Quirindi High School (Quirindi)",
  "Randwick High School (Randwick)",
  "Richmond Agricultural Centre (Richmond)",
  "Richmond High School (Richmond)",
  "Riverside Girls High School (Gladesville)",
  "Riverstone High School (Riverstone)",
  "Robert Townson High School (Raby)",
  "Rooty Hill High School (Rooty Hill)",
  "Rose Bay Secondary College (Dover Heights)",
  "Rouse Hill High School (Rouse Hill)",
  "Rutherford Technology High School (Rutherford)",
  "Ryde Secondary College (Ryde)",
  "Sarah Redfern High School (Minto)",
  "Scone High School (Scone)",
  "Sefton High School (Sefton)",
  "Seven Hills High School (Seven Hills)",
  "Shoalhaven High School (Nowra)",
  "Singleton High School (Singleton)",
  "Sir Joseph Banks High School (Revesby)",
  "Smiths Hill High School (Wollongong)",
  "South Grafton High School (South Grafton)",
  "South Sydney High School (Maroubra)",
  "Southern Cross School of Distance Education (East Ballina)",
  "Springwood High School (Faulconbridge)",
  "St Clair High School (St Clair)",
  "St George Girls High School (Kogarah)",
  "St Ives High School (St Ives)",
  "St Johns Park High School (St Johns Park)",
  "St Marys Senior High School (St Marys)",
  "Strathfield Girls High School (Strathfield)",
  "Strathfield South High School (Enfield)",
  "Swansea High School (Caves Beach)",
  "Sydney Boys High School (Moore Park)",
  "Sydney Distance Education High School (Woolloomooloo)",
  "Sydney Girls High School (Surry Hills)",
  "Sydney Secondary College Balmain Campus (Rozelle)",
  "Sydney Secondary College Blackwattle Bay Campus (Glebe)",
  "Sydney Secondary College Leichhardt Campus (Leichhardt)",
  "Sydney Technical High School (Bexley)",
  "Sylvania High School (Sylvania)",
  "Tamworth High School (South Tamworth)",
  "Taree High School (Taree)",
  "Temora High School (Temora)",
  "Tempe High School (Tempe)",
  "Tenterfield High School (Tenterfield)",
  "Terrigal High School (Terrigal)",
  "The Forest High School (Frenchs Forest)",
  "The Henry Lawson High School (Grenfell)",
  "The Hills Sports High School (Seven Hills)",
  "The Jannali High School (Jannali)",
  "The Ponds High School (The Ponds)",
  "The Rivers Secondary College, Kadina High Campus (Goonellabah)",
  "The Rivers Secondary College, Lismore High Campus (Lismore)",
  "The Rivers Secondary College, Richmond River High Campus (East Lismore)",
  "Thomas Reddall High School (Ambarvale)",
  "Tomaree High School (Salamander Bay)",
  "Toormina High School (Toormina)",
  "Toronto High School (Toronto)",
  "Tuggerah Lakes Secondary College Berkeley Vale Campus (Berkeley Vale)",
  "Tuggerah Lakes Secondary College The Entrance Campus (Shelly Beach)",
  "Tuggerah Lakes Secondary College Tumbi Umbi Campus (Tumbi Umbi)",
  "Tumbarumba High School (Tumbarumba)",
  "Tumut High School (Tumut)",
  "Turramurra High School (South Turramurra)",
  "Tweed River High School (Tweed Heads South)",
  "Ulladulla High School (Ulladulla)",
  "Vincentia High School (Vincentia)",
  "Wade High School (Griffith)",
  "Wagga Wagga High School (Wagga Wagga)",
  "Walgett Community College - High School (Walgett)",
  "Warialda High School (Warialda)",
  "Warilla High School (Barrack Heights)",
  "Warners Bay High School (Warners Bay)",
  "Warrawong High School (Warrawong)",
  "Wauchope High School (Wauchope)",
  "Wee Waa High School (Wee Waa)",
  "Wellington High School (Wellington)",
  "Wentworth Point High School (Wentworth Point)",
  "West Wallsend High School (West Wallsend)",
  "West Wyalong High School (West Wyalong)",
  "Westfields Sports High School (Fairfield West)",
  "Whitebridge High School (Whitebridge)",
  "Wiley Park Girls High School (Punchbowl)",
  "Willoughby Girls High School (Willoughby)",
  "Willyama High School (Broken Hill)",
  "Windsor High School (McGraths Hill)",
  "Wingham High School (Wingham)",
  "Winmalee High School (Winmalee)",
  "Wollongong High School of the Performing Arts (Fairy Meadow)",
  "Wollumbin High School (Murwillumbah)",
  "Woolgoolga High School (Woolgoolga)",
  "Woolooware High School (Woolooware)",
  "Woonona High School (Woonona)",
  "Wyndham College (Quakers Hill)",
  "Wyong High School (Wyong)",
  "Yanco Agricultural High School (Yanco)",
  "Yass High School (Yass)",
  "Young High School (Young)",

  // === CATHOLIC & INDEPENDENT SCHOOLS ===
  "Abbotsleigh (Wahroonga)",
  "Al Amanah College (Liverpool)",
  "Al Hikma College (Lakemba)",
  "Al Noori Muslim School (Greenacre)",
  "Al Sadiq College (Greenacre)",
  "Al Zahra College (Arncliffe)",
  "Alesco Secondary College (Cooks Hill)",
  "Al-Faisal College (Auburn)",
  "Al-Faisal College - Campbelltown (Minto)",
  "Al-Faisal College - Liverpool (Austral)",
  "All Saints Catholic College (Liverpool)",
  "All Saints College (Maitland)",
  "All Saints Grammar (Belmore)",
  "Alpha Omega Senior College (Auburn)",
  "Amity College (Prestons)",
  "Aquinas Catholic College (Menai)",
  "Arden Anglican School (Epping)",
  "Arise Christian College (Metford)",
  "Arkana College (Kingsgrove)",
  "Arndell Anglican College (Oakville)",
  "Arrahman College (Austral)",
  "Ascham School (Edgecliff)",
  "Australian Christian College - Marsden Park (Riverstone)",
  "Australian Christian College - Singleton (Singleton)",
  "Australian International Academy (North Kellyville)",
  "Australian International High School (Sydney)",
  "Australian Islamic College of Sydney (Mount Druitt)",
  "Australian Performing Arts Grammar School (Glebe)",
  "Avondale School (Cooranbong)",
  "Barker College (Hornsby)",
  "Bede Polding College (South Windsor)",
  "Bellfield College (Rossmore)",
  "Belmont Christian College (Belmont North)",
  "Bethany College (Hurstville)",
  "Bethel Christian School (Mount Druitt)",
  "Bishop Druitt College (Coffs Harbour)",
  "Bishop Tyrrell Anglican College (Fletcher)",
  "Blacktown Youth College (Hebersham)",
  "Blue Gum Community School (Hornsby)",
  "Blue Hills College (Goonellabah)",
  "Blue Mountains Grammar School (Wentworth Falls)",
  "Border Christian College (Thurgoona)",
  "Brigidine College Randwick (Randwick)",
  "Brigidine College St Ives (St Ives)",
  "Broughton Anglican College (Menangle Park)",
  "Calderwood Christian School (Albion Park)",
  "Calrossy Anglican School (Tamworth)",
  "Caroline Chisholm College (Glenmore Park)",
  "Carroll College (Broulee)",
  "Casimir Catholic College (Marrickville)",
  "Casino Christian School (North Casino)",
  "CathWest Innovation College (Mount Druitt)",
  "Catherine McAuley Catholic College (Medowie)",
  "Catherine McAuley Westmead (Westmead)",
  "Cedars Christian College (Unanderra)",
  "Central Coast Adventist School (Erina)",
  "Central Coast Grammar School (Erina Heights)",
  "Central Coast Sports College (Kariong)",
  "Central West Leadership Academy (Dubbo)",
  "Cerdon College (Merrylands)",
  "Charlton Christian College (Fassifern)",
  "Chevalier College (Burradoo)",
  "Christian Brothers High School Lewisham (Lewisham)",
  "Clancy Catholic College (West Hoxton)",
  "Claremont College (Randwick)",
  "Clarence Valley Anglican School (Clarenza)",
  "Coast Christian School (Bensville)",
  "Coffs Harbour Christian Community School (Bonville)",
  "Condell Park Christian School (Condell Park)",
  "Corpus Christi Catholic High School (Oak Flats)",
  "Corpus Christi College Maroubra (Maroubra)",
  "Covenant Christian School (Belrose)",
  "Cranbrook School (Bellevue Hill)",
  "Danebank - An Anglican School For Girls (Hurstville)",
  "De La Salle Catholic College, Caringbah (Caringbah)",
  "De La Salle College, Revesby Heights (Revesby Heights)",
  "Delany College (Granville)",
  "Domremy Catholic College (Five Dock)",
  "Dubbo Christian School (Dubbo)",
  "Ebenezer Christian College (Prospect)",
  "EDEN College (Macquarie Fields)",
  "Edmondson Park College (Edmondson Park)",
  "Edmund Rice College (West Wollongong)",
  "Emanuel School (Randwick)",
  "Emmanuel Anglican College (Ballina)",
  "Emmaus Catholic College (Kemps Creek)",
  "ET Australia Secondary College (Gosford)",
  "Freeman Catholic College (Bonnyrigg Heights)",
  "Frensham School (Mittagong)",
  "Galstaun College (Ingleside)",
  "Georges River Grammar (Georges Hall)",
  "German International School Sydney (Terrey Hills)",
  "Gilroy Catholic College (Castle Hill)",
  "Glenaeon Rudolf Steiner School (Middle Cove)",
  "GOAL College (Ultimo)",
  "Good Samaritan Catholic College (Hinchinbrook)",
  "Green Point Christian College (Green Point)",
  "Greenacre Christian College (Greenacre)",
  "Hennessy Catholic College (Young)",
  "Heritage Christian School (Port Macquarie)",
  "Heritage College Lake Macquarie (Morisset)",
  "Hills Adventist College (North Kellyville)",
  "Hinterland Christian College (Mullumbimby)",
  "Holy Cross College (Ryde)",
  "Holy Spirit Catholic College (Lakemba)",
  "Holy Spirit College (Bellambi)",
  "HopePoint Christian School (Georges Hall)",
  "Hunter Christian School (Mayfield)",
  "Hunter Trade College (Telarah)",
  "Hunter Valley Grammar School (Ashtonfield)",
  "Hurstville Adventist School (Hurstville)",
  "Illawarra Christian School (Cordeaux Heights)",
  "Inaburra School (Bangor)",
  "Indie School Albury (Albury)",
  "International Grammar School (Ultimo)",
  "International Maarif Schools of Australia (Auburn)",
  "Irfan College (Cecil Park)",
  "James Sheahan Catholic High School (Orange)",
  "John Colet School (Belrose)",
  "John Therry Catholic College (Rosemeadow)",
  "Kambala (Rose Bay)",
  "Kesser Torah College (Dover Heights)",
  "Key College (Redfern)",
  "Kildare Catholic College (Wagga Wagga)",
  "Kincoppal - Rose Bay School of the Sacred Heart (Rose Bay)",
  "Kinross Wolaroi School (Orange)",
  "Knox Grammar School (Wahroonga)",
  "Korowal School (Hazelbrook)",
  "La Salle Academy Lithgow (Lithgow)",
  "La Salle Catholic College (Bankstown)",
  "Lakes Grammar - An Anglican School (Warnervale)",
  "Leppington Anglican College (Leppington)",
  "Liberty College (Tamworth)",
  "Lindisfarne Anglican Grammar School (Terranora)",
  "Loreto Kirribilli (Kirribilli)",
  "Loreto Normanhurst (Normanhurst)",
  "Lumen Christi Catholic College (Pambula Beach)",
  "LYCEE CONDORCET The International French School of Sydney (Maroubra Junction)",
  "Macarthur Adventist College (Macquarie Fields)",
  "Macarthur Anglican School (Cobbitty)",
  "MacKillop Catholic College (Woongarrah)",
  "MacKillop College Bathurst (Bathurst)",
  "MacKillop College Port Macquarie (Port Macquarie)",
  "Macquarie Anglican Grammar School (Dubbo)",
  "Macquarie College (Wallsend)",
  "Macquarie Grammar School (Sydney)",
  "Magdalene Catholic College (Smeaton Grange)",
  "Maitland Christian School (Metford)",
  "Malek Fahd Islamic School (Greenacre)",
  "Mamre Anglican School (Kemps Creek)",
  "Manning Valley Anglican College (Cundletown)",
  "Marcellin College (Randwick)",
  "Margaret Jurd College (Shortland)",
  "Marian Catholic College (Kenthurst)",
  "Marian Catholic College (Griffith)",
  "Marist Catholic College North Shore (North Sydney)",
  "Marist Catholic College Penshurst (Mortdale)",
  "Marist College Eastwood (Eastwood)",
  "Marist College Kogarah (Bexley)",
  "Marist Sisters' College Woolwich (Woolwich)",
  "Maronite College of the Holy Family (Harris Park)",
  "Marsden Park Anglican College (Marsden Park)",
  "Mary MacKillop Catholic College (Wakeley)",
  "Masada College (St Ives)",
  "Mater Dei Catholic College (Lake Albert)",
  "Mater Maria Catholic College (Warriewood)",
  "McAuley Catholic College (Clarenza)",
  "McAuley Catholic College (Tumut)",
  "McCarthy Catholic College (West Tamworth)",
  "Medowie Christian School (Medowie)",
  "Mercy Catholic College (Chatswood)",
  "Meriden School (Strathfield)",
  "MidCoast Christian College (Taree)",
  "Minarah College (Green Valley)",
  "MLC School (Burwood)",
  "Moama Anglican Grammar School (Moama)",
  "Monte Sant' Angelo Mercy College (North Sydney)",
  "Montgrove College (Orchard Hills)",
  "Moree Christian School (Moree)",
  "Moriah College (Bondi Junction)",
  "Mount Annan Christian College (Mount Annan)",
  "Mount Carmel Catholic College (Varroville)",
  "Mount Sinai College (Maroubra)",
  "Mount St Benedict College (Pennant Hills)",
  "Mount St Patrick College (Murwillumbah)",
  "Mountain View Adventist College (Doonside)",
  "Mountains Christian College (Blackheath)",
  "Nagle College (Blacktown)",
  "Nambucca Valley Christian Community School (Nambucca Heads)",
  "Namoi Valley Christian School (Wee Waa)",
  "Narromine Christian School (Narromine)",
  "Nautilus Senior College (Port Macquarie)",
  "Nepean Christian School (Mulgoa)",
  "New England Girls' School (Armidale)",
  "New Hope Christian School (Dural)",
  "New Madinah College (Young)",
  "Newcastle Grammar School (The Hill)",
  "Newcastle Waldorf School (Glendale)",
  "Newington College (Stanmore)",
  "Newman Senior Technical College (Port Macquarie)",
  "Ngarra Christian College (Riverstone)",
  "Northcross Christian School (Ryde)",
  "Northern Beaches Christian School (Terrey Hills)",
  "Northholm Grammar School (Arcadia)",
  "Norwest Christian College (Riverstone)",
  "Nowra Anglican College (Bomaderry)",
  "Nowra Christian School (Nowra)",
  "Oakhill College (Castle Hill)",
  "O'Connor Catholic College (Armidale)",
  "Odyssey College (Eagle Vale)",
  "OneSchool Global NSW - Albury (Lavington)",
  "OneSchool Global NSW - Sydney (Oatlands)",
  "Oran Park Anglican College (Oran Park)",
  "Orange Anglican Grammar School (Orange)",
  "Orange Christian School (Orange)",
  "Our Lady of Mercy Catholic College Burraneer (Cronulla)",
  "Our Lady of Mercy College Parramatta (Parramatta)",
  "Our Lady of The Sacred Heart College (Kensington)",
  "Oxford Falls Grammar School (Oxford Falls)",
  "Oxley College (Burradoo)",
  "Pacific Berowra Christian School (Berowra)",
  "Pacific Brook Christian School (Muswellbrook)",
  "Pacific Coast Christian School (Tweed Heads South)",
  "Pacific Hills Christian School (Dural)",
  "Pacific Valley Christian School (Townsend)",
  "Pal Buddhist School (Canley Vale)",
  "Parkes Christian School (Parkes)",
  "Parramatta Marist High School (Westmead)",
  "Patrician Brothers' College Blacktown (Blacktown)",
  "Patrician Brothers' College Fairfield (Fairfield)",
  "Penola Catholic College Emu Plains (Emu Plains)",
  "Penrith Anglican College (Orchard Hills)",
  "Penrith Christian School (Orchard Hills)",
  "Pittwater House Schools (Collaroy)",
  "PLC Armidale (Armidale)",
  "Presbyterian Ladies' College Sydney (Croydon)",
  "Pymble Ladies' College (Pymble)",
  "Queenwood (Mosman)",
  "Ravenswood School for Girls (Gordon)",
  "Red Bend Catholic College (Forbes)",
  "Reddam House (Woollahra)",
  "Redeemer Baptist School (North Parramatta)",
  "Redfern Jarjum College (Redfern)",
  "Redfield College (Dural)",
  "Regents Park Christian School (Regents Park)",
  "Richard Johnson Anglican College (Oakhurst)",
  "Richmond Christian College (Ballina)",
  "Rissalah College (Lakemba)",
  "Rivers Christian College (Inverell)",
  "Rosebank College (Five Dock)",
  "Roseville College (Roseville)",
  "Rouse Hill Anglican College (Rouse Hill)",
  "Saint Ignatius' College (Lane Cove)",
  "Saint Mary MacKillop College Albury (Jindera)",
  "Saint Mary MacKillop Colleges Limited (Wagga Wagga)",
  "Salamah College (Chester Hill)",
  "San Clemente Catholic College (Mayfield)",
  "Santa Sabina College (Strathfield)",
  "Santa Sophia Catholic College (Gables)",
  "Sapphire Coast Anglican College (Bega)",
  "Sathya Sai College (Murwillumbah)",
  "SCECGS Redlands (Cremorne)",
  "SCEGGS Darlinghurst (Darlinghurst)",
  "Scone Grammar School (Scone)",
  "Scots All Saints College (White Rock)",
  "Shellharbour Anglican College (Dunmore)",
  "Sherwood Hills Christian School (Bradbury)",
  "Shire Christian School (Barden Ridge)",
  "Shoalhaven River College (Bomaderry)",
  "SHORE - Sydney Church of England Grammar School (North Sydney)",
  "Snowy Mountains Christian School (Cooma North)",
  "Snowy Mountains Grammar School (Jindabyne)",
  "Southern Cross Baptist Church Christian School (Engadine)",
  "Southern Cross Catholic College (Burwood)",
  "Southern Highlands Christian School (Bowral)",
  "St Agnes Catholic High School (Rooty Hill)",
  "St Aloysius' College (Kirribilli)",
  "St Aloysius College Cronulla (Cronulla)",
  "St Andrew's Cathedral School (Sydney)",
  "St Andrew's Christian School (Grafton)",
  "St Andrews College (Marayong)",
  "St Anne's Catholic College (Temora)",
  "St Anthony of Padua Catholic College (Austral)",
  "St Anthony's Coptic Orthodox College (Guildford)",
  "St Augustine's College Sydney (Brookvale)",
  "St Bede's Catholic College (Chisholm)",
  "St Benedict's Catholic College (Oran Park)",
  "St Bishoy Coptic Orthodox College (Mount Druitt)",
  "St Brigid's Catholic College (Lake Munmorah)",
  "St Catherine's Catholic College (Singleton)",
  "St Catherine's School (Waverley)",
  "St Charbel's College (Punchbowl)",
  "St Clare's Catholic High School (Hassall Grove)",
  "St Clare's College (Waverley)",
  "St Clare's High School (Taree)",
  "St Columba Anglican School (Port Macquarie)",
  "St Columba's Catholic College (Springwood)",
  "St Dominic's Catholic College (Mayfield)",
  "St Dominic's College (Kingswood)",
  "St Edmund's College (Wahroonga)",
  "St Edward's Christian Brothers' College (East Gosford)",
  "St Euphemia College (Bankstown)",
  "St Francis Catholic College (Edmondson Park)",
  "St Francis De Sales Regional College (Leeton)",
  "St Francis Xavier's College (Hamilton)",
  "St George Christian School (Hurstville)",
  "St Gregory's College Campbelltown (Gregory Hills)",
  "St John Bosco College (Engadine)",
  "St John Paul College (Coffs Harbour)",
  "St John Paul II Catholic College (Schofields)",
  "St John The Evangelist Catholic High School (Nowra)",
  "St John XXIII Catholic College (Stanhope Gardens)",
  "St Johns College Dubbo (Dubbo)",
  "St John's College Lismore (Lismore)",
  "St Joseph's Catholic College Aberdeen (Aberdeen)",
  "St Joseph's Catholic College East Gosford (East Gosford)",
  "St Joseph's Catholic High School (Albion Park)",
  "St Joseph's College (Banora Point)",
  "St Joseph's College (Lochinvar)",
  "St Joseph's College (Hunters Hill)",
  "St Joseph's Regional College (Port Macquarie)",
  "St Leo's Catholic College (Wahroonga)",
  "St Luke's Catholic College (Marsden Park)",
  "St Luke's Grammar School (Dee Why)",
  "St Mark's Coptic Orthodox College (Wattle Grove)",
  "St Maroun's College (Marrickville)",
  "St Mary and St Mina's Coptic Orthodox College (Bexley)",
  "St Mary Star of the Sea College (Wollongong)",
  "St Mary's Cathedral College (Sydney)",
  "St Mary's Catholic College (Casino)",
  "St Mary's Catholic College (Gateshead)",
  "St Mary's College Gunnedah (Gunnedah)",
  "St Narsai Assyrian Christian College (Horsley Park)",
  "St Patrick's College Campbelltown (Campbelltown)",
  "St Patrick's College Strathfield (Strathfield)",
  "St Patrick's College Sutherland (Sutherland)",
  "St Patrick's Marist College (Dundas)",
  "St Paul of the Cross Catholic High School (Dulwich Hill)",
  "St Paul's Catholic College (Booragul)",
  "St Paul's Catholic College (Greystanes)",
  "St Paul's Catholic College Junior Campus (Balgowlah)",
  "St Paul's College (West Kempsey)",
  "St Paul's College (Walla Walla)",
  "St Paul's Grammar School (Cranebrook)",
  "St Paul's International College (Moss Vale)",
  "St Peter's Anglican College - Broulee (Broulee)",
  "St Peter's Anglican Grammar (Campbelltown)",
  "St Peter's Catholic College (Tuggerah)",
  "St Philip's Christian College - Cessnock (Nulkaba)",
  "St Philip's Christian College - Gosford (Narara)",
  "St Philip's Christian College - Port Stephens (Salamander Bay)",
  "St Philip's Christian College - Waratah (Waratah)",
  "St Pius X College (Chatswood)",
  "St Sava College (Varroville)",
  "St Scholastica's College Glebe Point (Glebe)",
  "St Spyridon College (Maroubra)",
  "St Stanislaus' College (Bathurst)",
  "St Ursula's College (Kingsgrove)",
  "St Vincent's College (Potts Point)",
  "St Vincent's College Ashfield (Ashfield)",
  "Stella Maris College (Manly)",
  "Summerland Christian College (Goonellabah)",
  "Sydney Adventist School - Auburn (Auburn)",
  "Sydney Grammar School (Darlinghurst)",
  "Sydney Japanese International School (Terrey Hills)",
  "Tangara School for Girls (Cherrybrook)",
  "Tara Anglican School for Girls (North Parramatta)",
  "The Alpine School (Cooma)",
  "The Anglican School Googong (Googong)",
  "The Armidale School (Armidale)",
  "The Hills Grammar School (Kenthurst)",
  "The Illawarra Grammar School (Wollongong West)",
  "The King's School (North Parramatta)",
  "The Lakes Christian College (Castlereagh)",
  "The Lakes College (Blue Haven)",
  "The McDonald College (North Strathfield)",
  "The Riverina Anglican College (Wagga Wagga)",
  "The Scots College (Bellevue Hill)",
  "The Scots School Albury (Albury)",
  "Thomas Hassall Anglican College (Middleton Grange)",
  "Toongabbie Christian College (Toongabbie)",
  "Toronto Adventist School (Toronto)",
  "Trinity Anglican College - Albury (Thurgoona)",
  "Trinity Catholic College (Adamstown)",
  "Trinity Catholic College (Auburn)",
  "Trinity Catholic College Goulburn (Goulburn)",
  "Trinity Catholic College Lismore (East Lismore)",
  "Trinity Grammar School (Summer Hill)",
  "Tyndale Christian School (Blacktown)",
  "Unity Grammar College (Austral)",
  "Verity Christian College (Griffith)",
  "Wagga Wagga Christian College (Wagga Wagga)",
  "Wahroonga Adventist School (Wahroonga)",
  "Warakirri College (Fairfield)",
  "Waverley College (Waverley)",
  "Wellington Christian School (Wellington)",
  "Wenona School (North Sydney)",
  "Westbourne College Sydney (Ultimo)",
  "Western Grammar School (Plumpton)",
  "Westmead Christian Grammar School (Westmead)",
  "William Campbell College (Nowra Hill)",
  "William Carey Christian School (Prestons)",
  "William Clarke College (Kellyville)",
  "Wollemi College (Werrington)",
  "Wollondilly Anglican College (Tahmoor)",
  "Wycliffe Christian School (Warrimoo)",
  "Wyong Christian Community School (Wyong)",
  "Xavier Catholic College (North Albury)",
  "Xavier Catholic College Ballina (Skennars Head)",
  "Xavier College (Llandilo)",
  "Zahra Grammar School (Minto)",
].sort();

export default nswSchools;
